import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="border-t border-slate-200 bg-white mt-20"
      data-testid="app-footer"
    >
      <div className="et-section py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
        <div className="flex items-center gap-1.5">
          <span className="font-serif text-sm text-navy">Talkademia</span>
          <span aria-hidden="true">·</span>
          <span className="italic">Education happens through communication and conversation.</span>
        </div>
        <nav className="flex items-center gap-4" aria-label="Footer">
          <Link to="/terms" className="hover:text-teal transition-colors" data-testid="footer-terms">Terms</Link>
          <Link to="/privacy" className="hover:text-teal transition-colors" data-testid="footer-privacy">Privacy</Link>
          <Link to="/contact" className="hover:text-teal transition-colors" data-testid="footer-contact">Contact</Link>
          <span className="text-slate-400">© {new Date().getFullYear()}</span>
        </nav>
      </div>
    </footer>
  );
}
